import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=d0cb3e5e&scoped=true"
import script from "./alert.vue?vue&type=script&lang=ts"
export * from "./alert.vue?vue&type=script&lang=ts"
import style0 from "./alert.vue?vue&type=style&index=0&id=d0cb3e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cb3e5e",
  null
  
)

export default component.exports